class AuctionPerformance {
  constructor(data) {
    this.id = data._id;
    this.number_of_lots = data.number_of_lots;
    this.total_amount = data.total_amount;
  }
}

export default AuctionPerformance;
